module.exports = __webpack_public_path__ + "img/1472912513.e49911c8.jpg";